import { useFullStory } from '@goshippo/utilities';
import { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { getUser } from '~/selectors/user.selectors';
import { getFullName } from '~/types/User';
import { trackingHelper } from '~/utils/TrackingHelper';
import { getCookie } from '~/utils/cookies';

// Watches for changes to user information and if available,
// calls fullstory identify with user info
const FullStoryMonitor = () => {
  const { isInitialized, identify, event: fullstoryEvent } = useFullStory();

  const [fsIdentifyCalled, setFsIdentifyCalled] = useState<boolean>(false);

  const user = useSelector(getUser);

  const isFsInitialized = isInitialized();
  const isImpersonatingCookie = getCookie('is_impersonate') || '';
  const isImpersonating = isImpersonatingCookie.toLowerCase() === 'true';

  // Identify user in fullstory once initialized
  useEffect(() => {
    if (user && isFsInitialized && !fsIdentifyCalled && !isImpersonating) {
      identify(user.id.toString(), {
        displayName: getFullName(user),
        email: user.email,
      });
      setFsIdentifyCalled(true);
    }
  }, [user, isFsInitialized, fsIdentifyCalled, identify, isImpersonating]);

  useEffect(() => {
    trackingHelper.fullStoryEvent = fullstoryEvent;
  }, [fullstoryEvent]);

  return null;
};

export default FullStoryMonitor;
